import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'BaseLink' })(() => ({
  root: {
    textDecoration: 'none',
    lineHeight: 1,
  },
}));

export default useStyles;
